import { useState } from 'react'
import { Button, SectionContainer } from '@/components/shared'
import { imageAssets } from '@/assets/images'
import heroVideo from '@/assets/video_hero_verticals_720.mp4'
import { trackEvent } from '@/lib/analytics/gtm'
import ContactPanel from './ContactPanel'
import { websiteContent } from '../content'
import { usePanelViewTracking } from '../hooks/usePanelViewTracking'

const { hero, navigation } = websiteContent

function HeroSection() {
  const [isContactPanelOpen, setIsContactPanelOpen] = useState(false)

  usePanelViewTracking({
    panelId: 'hero',
    panelName: 'Hero',
    panelIndex: 0,
  })

  return (
    <SectionContainer
      id="hero"
      size="page"
      className="relative min-h-[798px] overflow-hidden bg-brand-green text-white md:min-h-[clamp(720px,100vh,1024px)]"
      innerClassName="relative min-h-[798px] !px-0 md:min-h-[clamp(720px,100vh,1024px)]"
    >
      <div className="absolute inset-0 z-0">
        <video
          className="h-full w-full object-cover"
          muted
          loop
          playsInline
          autoPlay
          aria-hidden="true"
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-brand-green/15" />
      </div>

      <div className="absolute left-0 right-0 top-0 z-10 h-[201px] md:hidden">
        <img src={imageAssets.hero.overlayMobile} alt="" className="h-full w-full" aria-hidden="true" />
      </div>

      <div className="absolute left-0 right-0 top-0 z-10 hidden bg-brand-green md:block md:h-[clamp(72px,8vw,96px)]" />

      <div className="absolute left-0 right-0 z-10 hidden md:top-[clamp(64px,8vw,80px)] md:block md:h-[clamp(180px,30vw,444px)]">
        <img
          src={imageAssets.hero.overlay}
          alt=""
          className="h-full w-full"
          aria-hidden="true"
        />
      </div>

      <div className="absolute right-[24px] top-4 z-30 flex items-center justify-end md:top-6">
        {/* TODO(nxt-phase2): Re-enable the primary phone CTA (currently hidden) with dedicated analytics payload. */}
        <Button
          variant="brand"
          className="uppercase !bg-brand-greenBright !text-brand-green !min-h-[44px] !rounded-none !py-0 md:!rounded-[2px]"
          onClick={() => {
            trackEvent('cta_click', {
              cta_label: navigation.secondaryCta,
              cta_location: 'hero',
            })
            setIsContactPanelOpen(true)
          }}
        >
          {navigation.secondaryCta}
        </Button>
      </div>

      <div className="relative z-20 min-h-[798px] px-page-gutter md:min-h-[clamp(720px,100vh,1024px)]">
        <h1 className="sr-only">
          NXT Humans: Human-first AI solutions for retail, finance, healthcare, and higher
          education
        </h1>

        <div className="absolute bottom-10 left-4 right-4 max-w-[313px] md:bottom-[clamp(48px,8vw,88px)] md:left-[clamp(16px,4vw,24px)] md:right-[clamp(16px,4vw,24px)] md:max-w-[684px]">
          <p className="font-archivo text-[26px] font-normal leading-[34px] text-white md:text-[clamp(1.375rem,3vw,2rem)] md:leading-[clamp(1.75rem,3.8vw,2.5rem)]">
            {hero.subtitle}
          </p>
          <p className="mt-6 font-archivo text-[26px] font-normal leading-[34px] text-white/90 md:mt-[clamp(1rem,2.2vw,1.5rem)] md:text-[clamp(1.375rem,3vw,2rem)] md:leading-[clamp(1.75rem,3.8vw,2.5rem)]">
            {hero.description}
          </p>
        </div>
      </div>

      <ContactPanel isOpen={isContactPanelOpen} onClose={() => setIsContactPanelOpen(false)} />
    </SectionContainer>
  )
}

export default HeroSection
